import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import PrimaryButton from '../../components/Buttons/PrimaryButton/PrimaryButton';
import SecondaryButton from '../../components/Buttons/SecondaryButton/SecondaryButton';
import TextField from '../../components/TextField/TextField';
import { setFormData } from '../../app/slices/formSlice';
import Page from '../../components/Page/Page';
import style from './AccountPage.module.scss';
import store from '../../app/store/store';
import api from '../../core/api';

export default function AccountPage() {
  const [state, setState] = useState({});
  const [buttonText, setButtonText] = useState('Non voglio inserire altre informazioni');
  const initialValues = {
    userEmail: '',
    userPassword: '',
    userPasswordConfirm: '',
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleNextStep = (values) => {
    dispatch(setFormData(values));
    navigate('/orari');
  };
  const handleSendData = async (values) => {
    await dispatch(setFormData(values));
    await setState({
      form: store.getState().form.form,
      giorni: store.getState().orari.giorni,
      servizi: store.getState().servizi.servizi,
      poltrone: store.getState().poltrone.poltrone,
    });
    api.post('/business/auth/autoSignUp', state).then((res) => (res.status === 200 ? navigate('/riepilogo') : setButtonText('Riprova')));
  };

  const validationSchema = Yup.object({
    userEmail: Yup.string()
      .email('Inserisci una e-mail valida')
      .required('Inserisci la tua e-mail'),
    userPassword: Yup.string()
      .min(6, 'La password deve contenere almeno 6 caratteri')
      .required('Inserisci la tua password'),
    userPasswordConfirm: Yup.string()
      .oneOf([Yup.ref('userPassword'), null], 'Le password non coincidono'),
  });

  return (
    <Page>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          handleNextStep(values);
        }}
      >
        {({ values, handleChange }) => (
          <Form className={clsx(style.form)}>
            <h2 className={clsx(style.page__title)}>Il tuo account: </h2>
            <div className={clsx(style.form__fields)}>
              <TextField
                name="userEmail"
                label="Inserisci la tua e-mail"
                onChange={handleChange}
                fullWidth
                type="email"
              />

              <TextField
                name="userPassword"
                label="Crea password"
                type="password"
                fullWidth
                onChange={handleChange}
              />

              <TextField
                name="userPasswordConfirm"
                label="Conferma password"
                type="password"
                fullWidth
                onChange={handleChange}
              />
            </div>
            <div className={clsx(style.form__button)}>
              <PrimaryButton type="submit" label="Avanti" fullWidth />
              <SecondaryButton type="button" label={buttonText} onClick={() => handleSendData(values)} fullWidth />
            </div>
          </Form>
        )}
      </Formik>
    </Page>
  );
}
